import { render, staticRenderFns } from "./rudimentaryTask.vue?vue&type=template&id=6a293642&scoped=true"
import script from "./rudimentaryTask.vue?vue&type=script&lang=js"
export * from "./rudimentaryTask.vue?vue&type=script&lang=js"
import style0 from "./rudimentaryTask.vue?vue&type=style&index=0&id=6a293642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a293642",
  null
  
)

export default component.exports